/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum StickySeverity {
  Warning = "warning",
  Critical = "critical",
}

export function instanceOfStickySeverity(value: any): boolean {
  for (const key in StickySeverity) {
    if (Object.prototype.hasOwnProperty.call(StickySeverity, key)) {
      if (StickySeverity[key as keyof typeof StickySeverity] === value) {
        return true;
      }
    }
  }
  return false;
}

export function StickySeverityFromJSON(json: any): StickySeverity {
  return StickySeverityFromJSONTyped(json, false);
}

export function StickySeverityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StickySeverity {
  return json as StickySeverity;
}

export function StickySeverityToJSON(value?: StickySeverity | null): any {
  return value as any;
}

export function StickySeverityToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): StickySeverity {
  return value as StickySeverity;
}
